(function(root, factory) {
  'use strict';

  if (typeof module === 'object' && module.exports && typeof document === 'undefined') {
    module.exports = factory(null, null);
    return;
  }

  if (!root.xpertzaStickyAtc) {
    root.xpertzaStickyAtc = factory(root, root.document);
  }

  root.xpertzaStickyAtc.init();
}(typeof window !== 'undefined' ? window : this, function(window, document) {
  'use strict';

  var lifecycleBound = false;

  function normalizeQuantity(value) {
    var quantity = parseInt(value, 10);
    return quantity > 0 ? quantity : 1;
  }

  function getVariantById(variants, id) {
    var target = String(id);

    for (var index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === target) {
        return variants[index];
      }
    }

    return null;
  }

  function hasMeaningfulIntersection(rect, viewportHeight) {
    return Boolean(rect) && rect.bottom > 2 && rect.top < viewportHeight - 2;
  }

  function shouldShowSticky(mainRect, viewportHeight, footerRect, overlayIsOpen) {
    if (!mainRect || overlayIsOpen) {
      return false;
    }

    if (footerRect && footerRect.top <= viewportHeight) {
      return false;
    }

    return mainRect.top <= viewportHeight / 2;
  }

  function shouldShowStickyMobile(mainRect, viewportHeight, footerRect, overlayIsOpen) {
    if (!mainRect || overlayIsOpen) {
      return false;
    }

    if (footerRect && footerRect.top <= viewportHeight) {
      return false;
    }

    return (mainRect.top + mainRect.bottom) / 2 <= viewportHeight / 2;
  }

  function parseVariants(rootElement) {
    var dataId = rootElement.getAttribute('data-xpertza-variant-data-id');
    var dataElement = dataId ? document.getElementById(dataId) : null;

    if (!dataElement) {
      return [];
    }

    try {
      return JSON.parse(dataElement.textContent || dataElement.innerHTML || '[]');
    } catch (error) {
      return [];
    }
  }

  function createChangeEvent() {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('change', true, false);
    return event;
  }

  function setMainVariant(section, variant) {
    if (!section || !variant || !variant.options) {
      return false;
    }

    var changedElements = [];

    for (var optionIndex = 0; optionIndex < variant.options.length; optionIndex += 1) {
      var optionName = 'option' + (optionIndex + 1);
      var wrapper = section.querySelector('.variant-input-wrap[data-index="' + optionName + '"]');

      if (!wrapper) {
        continue;
      }

      var select = wrapper.querySelector('select');
      if (select) {
        if (select.value !== variant.options[optionIndex]) {
          changedElements.push(select);
        }
        select.value = variant.options[optionIndex];
        continue;
      }

      var radios = wrapper.querySelectorAll('input[type="radio"]');
      for (var radioIndex = 0; radioIndex < radios.length; radioIndex += 1) {
        if (radios[radioIndex].value === variant.options[optionIndex]) {
          if (!radios[radioIndex].checked) {
            changedElements.push(radios[radioIndex]);
          }
          radios[radioIndex].checked = true;
          break;
        }
      }
    }

    for (var changedIndex = 0; changedIndex < changedElements.length; changedIndex += 1) {
      changedElements[changedIndex].dispatchEvent(createChangeEvent());
    }

    return changedElements.length > 0;
  }

  function initRoot(rootElement) {
    if (rootElement.getAttribute('data-xpertza-sticky-initialized') === 'true') {
      return;
    }

    var sectionId = rootElement.getAttribute('data-xpertza-section-id');
    var formId = rootElement.getAttribute('data-xpertza-form-id');
    var section = document.getElementById('ProductSection-' + sectionId);
    var form = formId ? document.getElementById(formId) : null;
    var masterSelect = form ? form.querySelector('[name="id"]') : null;
    var mainButton = form ? form.querySelector('[name="add"]') : null;
    var mainQuantity = form ? form.querySelector('[name="quantity"]') : null;
    var stickyVariant = rootElement.querySelector('[data-xpertza-sticky-variant]');
    var stickyQuantity = rootElement.querySelector('[data-xpertza-sticky-quantity]');
    var minusButton = rootElement.querySelector('[data-xpertza-sticky-quantity-minus]');
    var plusButton = rootElement.querySelector('[data-xpertza-sticky-quantity-plus]');
    var stickyButton = rootElement.querySelector('[data-xpertza-sticky-submit]');
    var stickyButtonText = stickyButton;
    var price = rootElement.querySelector('[data-xpertza-sticky-price]');
    var comparePrice = rootElement.querySelector('[data-xpertza-sticky-compare-price]');
    var thumbnail = rootElement.querySelector('[data-xpertza-sticky-thumbnail]');
    var footer = document.querySelector('.site-footer');
    var variants = parseVariants(rootElement);
    var busy = false;
    var sawMotionLoading = false;
    var framePending = false;
    var buttonObserver = null;
    var buttonClassObserver = null;
    var bodyClassObserver = null;
    var requestFrame = window.requestAnimationFrame || function(callback) {
      return window.setTimeout(callback, 16);
    };

    if (!section || !form || !masterSelect || !mainButton || !stickyButton || !window.jQuery) {
      return;
    }

    rootElement.setAttribute('data-xpertza-sticky-initialized', 'true');

    function formatMoney(cents) {
      if (!window.theme || !window.theme.Currency || typeof window.theme.Currency.formatMoney !== 'function') {
        return '';
      }

      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }

    function currentVariant() {
      return getVariantById(variants, masterSelect.value);
    }

    function updateVariant(variant) {
      var addText = stickyButton.getAttribute('data-xpertza-add-text');
      var soldOutText = stickyButton.getAttribute('data-xpertza-sold-out-text');
      var unavailableText = stickyButton.getAttribute('data-xpertza-unavailable-text');

      function updateButtonLabel(label) {
        var visibleLabel = label || addText || 'Add to cart';
        stickyButtonText.textContent = visibleLabel;
        stickyButton.setAttribute('aria-label', visibleLabel);
      }

      if (!variant || (variant.available !== true && variant.available !== false)) {
        stickyButton.disabled = true;
        updateButtonLabel(unavailableText);
        return;
      }

      if (stickyVariant) {
        stickyVariant.value = String(variant.id);
      }

      var formattedPrice = formatMoney(variant.price);
      if (formattedPrice) {
        price.textContent = formattedPrice;
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var formattedComparePrice = formatMoney(variant.compare_at_price);
        comparePrice.textContent = formattedComparePrice;
        comparePrice.hidden = !formattedComparePrice;
      } else {
        comparePrice.textContent = '';
        comparePrice.hidden = true;
      }

      if (thumbnail && variant.featured_image) {
        thumbnail.src = variant.featured_image;
      }

      stickyButton.disabled = busy || !variant.available;
      updateButtonLabel(variant.available ? addText : soldOutText);
    }

    function updateQuantity(value) {
      if (stickyQuantity) {
        stickyQuantity.value = normalizeQuantity(value);
      }
    }

    function syncQuantityToMain(value) {
      var quantity = normalizeQuantity(value);
      updateQuantity(quantity);

      if (mainQuantity) {
        mainQuantity.value = quantity;
        mainQuantity.dispatchEvent(createChangeEvent());
      }
    }

    function releaseSubmission() {
      busy = false;
      sawMotionLoading = false;
      rootElement.classList.remove('xpertza-sticky-atc--loading');
      updateVariant(currentVariant());
    }

    function overlayOpen() {
      var body = document.body;
      return body.classList.contains('js-drawer-open') ||
        Boolean(document.querySelector('.modal--is-active')) ||
        Boolean(document.querySelector('.pswp--open'));
    }

    function shouldBeVisible() {
      var mainRect = mainButton.getBoundingClientRect();
      var footerRect = footer ? footer.getBoundingClientRect() : null;

      if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
        return shouldShowStickyMobile(mainRect, window.innerHeight, footerRect, overlayOpen());
      }

      return shouldShowSticky(mainRect, window.innerHeight, footerRect, overlayOpen());
    }

    function renderVisibility() {
      framePending = false;
      var visible = shouldBeVisible();

      document.body.classList.toggle('xpertza-sticky-atc-visible', visible);

      if (visible) {
        rootElement.hidden = false;
        rootElement.setAttribute('aria-hidden', 'false');
        rootElement.classList.add('xpertza-sticky-atc--visible');
      } else {
        rootElement.classList.remove('xpertza-sticky-atc--visible');
        rootElement.setAttribute('aria-hidden', 'true');
        rootElement.hidden = true;
      }
    }

    function scheduleVisibility() {
      if (framePending) {
        return;
      }

      framePending = true;
      requestFrame(renderVisibility);
    }

    window.jQuery(section)
      .off('variantChange.xpertzaStickyAtc')
      .on('variantChange.xpertzaStickyAtc', function(event) {
        updateVariant(event.variant || null);
      });

    window.jQuery('body')
      .off('qty.product.xpertzaStickyAtc')
      .on('qty.product.xpertzaStickyAtc', function(event, key, quantity) {
        updateQuantity(mainQuantity ? mainQuantity.value : quantity);
      });

    if (stickyVariant) {
      stickyVariant.addEventListener('change', function() {
        var variant = getVariantById(variants, stickyVariant.value);
        setMainVariant(section, variant);
        updateVariant(currentVariant());
      });
    }

    if (stickyQuantity) {
      stickyQuantity.addEventListener('change', function() {
        syncQuantityToMain(stickyQuantity.value);
      });
    }

    if (minusButton) {
      minusButton.addEventListener('click', function() {
        syncQuantityToMain(normalizeQuantity(stickyQuantity.value) - 1);
      });
    }

    if (plusButton) {
      plusButton.addEventListener('click', function() {
        syncQuantityToMain(normalizeQuantity(stickyQuantity.value) + 1);
      });
    }

    stickyButton.addEventListener('click', function() {
      if (busy) {
        return;
      }

      var variant = currentVariant();
      if (!variant || !variant.available) {
        updateVariant(variant);
        return;
      }

      if (mainQuantity) {
        mainQuantity.value = normalizeQuantity(mainQuantity.value);
        updateQuantity(mainQuantity.value);
      }

      busy = true;
      rootElement.classList.add('xpertza-sticky-atc--loading');
      stickyButton.disabled = true;
      mainButton.click();
    });

    if (window.MutationObserver) {
      buttonClassObserver = new window.MutationObserver(function() {
        if (mainButton.classList.contains('btn--loading')) {
          sawMotionLoading = true;
        } else if (busy && sawMotionLoading) {
          releaseSubmission();
        }
      });
      buttonClassObserver.observe(mainButton, { attributes: true, attributeFilter: ['class'] });

      bodyClassObserver = new window.MutationObserver(scheduleVisibility);
      bodyClassObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (window.IntersectionObserver) {
      buttonObserver = new window.IntersectionObserver(scheduleVisibility, {
        threshold: [0, 0.01, 0.5, 1]
      });
      buttonObserver.observe(mainButton);
      if (footer) {
        buttonObserver.observe(footer);
      }
    }

    document.addEventListener('ajaxProduct:added', releaseSubmission);
    document.addEventListener('ajaxProduct:error', releaseSubmission);
    window.addEventListener('scroll', scheduleVisibility, { passive: true });
    window.addEventListener('resize', scheduleVisibility);

    rootElement.xpertzaStickyCleanup = function() {
      window.jQuery(section).off('variantChange.xpertzaStickyAtc');
      window.jQuery('body').off('qty.product.xpertzaStickyAtc');
      document.removeEventListener('ajaxProduct:added', releaseSubmission);
      document.removeEventListener('ajaxProduct:error', releaseSubmission);
      window.removeEventListener('scroll', scheduleVisibility);
      window.removeEventListener('resize', scheduleVisibility);

      if (buttonObserver) {
        buttonObserver.disconnect();
      }
      if (buttonClassObserver) {
        buttonClassObserver.disconnect();
      }
      if (bodyClassObserver) {
        bodyClassObserver.disconnect();
      }

      document.body.classList.remove('xpertza-sticky-atc-visible');
      rootElement.removeAttribute('data-xpertza-sticky-initialized');
      rootElement.xpertzaStickyCleanup = null;
    };

    updateQuantity(mainQuantity ? mainQuantity.value : 1);
    updateVariant(currentVariant());
    scheduleVisibility();
  }

  function getRoots(container) {
    var scope = container && container.querySelectorAll ? container : document;
    var roots = [];
    var descendants = scope.querySelectorAll('[data-xpertza-sticky-atc]');

    if (scope.matches && scope.matches('[data-xpertza-sticky-atc]')) {
      roots.push(scope);
    }

    for (var index = 0; index < descendants.length; index += 1) {
      roots.push(descendants[index]);
    }

    return roots;
  }

  function initAll(container) {
    var roots = getRoots(container);

    for (var index = 0; index < roots.length; index += 1) {
      initRoot(roots[index]);
    }
  }

  function init() {
    if (!document) {
      return;
    }

    if (!lifecycleBound) {
      lifecycleBound = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          initAll(document);
        });
      }

      document.addEventListener('shopify:section:load', function(event) {
        initAll(event.target);
      });

      document.addEventListener('shopify:section:unload', function(event) {
        var roots = getRoots(event.target);

        for (var index = 0; index < roots.length; index += 1) {
          if (typeof roots[index].xpertzaStickyCleanup === 'function') {
            roots[index].xpertzaStickyCleanup();
          }
        }
      });
    }

    if (document.readyState !== 'loading') {
      initAll(document);
    }
  }

  return {
    getVariantById: getVariantById,
    hasMeaningfulIntersection: hasMeaningfulIntersection,
    init: init,
    normalizeQuantity: normalizeQuantity,
    setMainVariant: setMainVariant,
    shouldShowSticky: shouldShowSticky,
    shouldShowStickyMobile: shouldShowStickyMobile
  };
}));
